// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import XngZone from "@awc/App/Components/Common/XngZone";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { HasShellContext, withIsInShell } from "@insite/client-framework/Components/IsInShell";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React from "react";

interface OwnProps extends WidgetProps {}

type Props = OwnProps & HasShellContext;

export interface OrderDetailsInformationLayoutStyles {
    wrapper?: InjectableCss;
}

export const informationLayoutStyles: OrderDetailsInformationLayoutStyles = {};

const styles = informationLayoutStyles;

const OrderDetailsInformationLayout = ({ id }: Props) => {
    return (
        <StyledWrapper {...styles.wrapper}>
            <StyledWrapper>
                <XngZone contentId={id} zoneName="OrderDetailsLeftInformation" hint="OrderDetails Left Information" />
            </StyledWrapper>
            <StyledWrapper>
                <XngZone contentId={id} zoneName="OrderDetailsRightInformation" hint="OrderDetails Right Information" />
            </StyledWrapper>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: withIsInShell(OrderDetailsInformationLayout),
    definition: {
        allowedContexts: ["OrderDetailsPage", "VmiOrderDetailsPage"],
        group: "Order Details",
    },
};

export default widgetModule;
